function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
export var LinkWrapper = styled.a(_templateObject(), function (p) {
  return p.theme.variables.fonts.size.smaller1;
}, function (p) {
  return p.theme.variables.fonts.weight.regular;
}, function (p) {
  return p.theme.variables.colors.red;
});